module.exports = __webpack_public_path__ + "img/save.fb25986c.svg";